import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const FeatureCard = ({ dashboardData }) => {
  const navigate = useNavigate();
  const data = [
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 56 56"
          fill="none"
        >
          <g clip-path="url(#clip0_0_1587)">
            <path
              d="M28.2891 15.743L34.3113 18.9094L33.161 12.2033L38.0362 7.45227L31.3004 6.47413L28.2891 0.360352L25.2778 6.47413L18.542 7.45227L23.4172 12.2033L22.2669 18.9094L28.2891 15.743Z"
              fill="#1C2E4F"
            />
            <path
              d="M48.6359 17.3882L45.6246 11.2861L42.6133 17.3882L35.8809 18.3663L40.7527 23.1162L39.6024 29.8235L45.6246 26.6571L51.6502 29.8235L50.4965 23.1162L55.684 18.3663L48.6359 17.3882Z"
              fill="#1C2E4F"
            />
            <path
              d="M6.082 23.1162L4.9283 29.8235L10.9539 26.6571L16.9761 29.8235L15.8258 23.1162L20.6976 18.3663L13.9652 17.3882L10.9539 11.2861L7.94255 17.3882L0.894531 18.3663L6.082 23.1162Z"
              fill="#1C2E4F"
            />
            <path
              d="M36.3152 30.9652C36.3152 26.5402 32.7144 22.9395 28.2894 22.9395C23.8644 22.9395 20.2637 26.5402 20.2637 30.9652C20.2637 35.3902 23.8644 38.9909 28.2894 38.9909C32.7144 38.9909 36.3152 35.3902 36.3152 30.9652Z"
              fill="#1C2E4F"
            />
            <path
              d="M17.0527 50.2268V55.1492H39.5248V50.2268C39.5248 44.0319 34.4836 38.9907 28.2888 38.9907C22.0939 38.9907 17.0527 44.0319 17.0527 50.2268Z"
              fill="#1C2E4F"
            />
            <path
              d="M52.3663 53.4369C52.3663 49.0118 48.7656 45.4111 44.3405 45.4111C43.5104 45.4111 42.7253 45.5742 41.9717 45.8091C42.4261 47.2102 42.7354 48.6762 42.7354 50.2266V55.149H52.3663V53.4369Z"
              fill="#1C2E4F"
            />
            <path
              d="M50.7611 38.9909C50.7611 35.45 47.8815 32.5703 44.3405 32.5703C40.7996 32.5703 37.9199 35.45 37.9199 38.9909C37.9199 39.1953 37.9613 39.3884 37.9801 39.5878C39.5631 41.0308 40.8397 42.7918 41.6598 44.8062C42.4783 45.1854 43.3808 45.4115 44.3405 45.4115C47.8815 45.4115 50.7611 42.5318 50.7611 38.9909Z"
              fill="#1C2E4F"
            />
            <path
              d="M18.5984 39.5878C18.6172 39.3884 18.6586 39.1953 18.6586 38.9909C18.6586 35.45 15.7789 32.5703 12.238 32.5703C8.69704 32.5703 5.81738 35.45 5.81738 38.9909C5.81738 42.5318 8.69704 45.4115 12.238 45.4115C13.1977 45.4115 14.1002 45.1854 14.9187 44.8066C15.7388 42.7918 17.0154 41.0308 18.5984 39.5878Z"
              fill="#1C2E4F"
            />
            <path
              d="M4.21191 53.4369V55.149H13.8428V50.2266C13.8428 48.6762 14.1521 47.2102 14.6065 45.8091C13.8528 45.5742 13.0678 45.4111 12.2377 45.4111C7.81263 45.4111 4.21191 49.0118 4.21191 53.4369Z"
              fill="#1C2E4F"
            />
          </g>
          <defs>
            <clipPath id="clip0_0_1587">
              <rect
                width="54.7891"
                height="54.7891"
                fill="white"
                transform="translate(0.894531 0.360352)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      label: "Total Users",
      value: dashboardData?.totalCustomers || "-",
      redirectPath: "/manage-user",
    },
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 56 56"
          fill="none"
        >
          <g clip-path="url(#clip0_0_1587)">
            <path
              d="M28.2891 15.743L34.3113 18.9094L33.161 12.2033L38.0362 7.45227L31.3004 6.47413L28.2891 0.360352L25.2778 6.47413L18.542 7.45227L23.4172 12.2033L22.2669 18.9094L28.2891 15.743Z"
              fill="#1C2E4F"
            />
            <path
              d="M48.6359 17.3882L45.6246 11.2861L42.6133 17.3882L35.8809 18.3663L40.7527 23.1162L39.6024 29.8235L45.6246 26.6571L51.6502 29.8235L50.4965 23.1162L55.684 18.3663L48.6359 17.3882Z"
              fill="#1C2E4F"
            />
            <path
              d="M6.082 23.1162L4.9283 29.8235L10.9539 26.6571L16.9761 29.8235L15.8258 23.1162L20.6976 18.3663L13.9652 17.3882L10.9539 11.2861L7.94255 17.3882L0.894531 18.3663L6.082 23.1162Z"
              fill="#1C2E4F"
            />
            <path
              d="M36.3152 30.9652C36.3152 26.5402 32.7144 22.9395 28.2894 22.9395C23.8644 22.9395 20.2637 26.5402 20.2637 30.9652C20.2637 35.3902 23.8644 38.9909 28.2894 38.9909C32.7144 38.9909 36.3152 35.3902 36.3152 30.9652Z"
              fill="#1C2E4F"
            />
            <path
              d="M17.0527 50.2268V55.1492H39.5248V50.2268C39.5248 44.0319 34.4836 38.9907 28.2888 38.9907C22.0939 38.9907 17.0527 44.0319 17.0527 50.2268Z"
              fill="#1C2E4F"
            />
            <path
              d="M52.3663 53.4369C52.3663 49.0118 48.7656 45.4111 44.3405 45.4111C43.5104 45.4111 42.7253 45.5742 41.9717 45.8091C42.4261 47.2102 42.7354 48.6762 42.7354 50.2266V55.149H52.3663V53.4369Z"
              fill="#1C2E4F"
            />
            <path
              d="M50.7611 38.9909C50.7611 35.45 47.8815 32.5703 44.3405 32.5703C40.7996 32.5703 37.9199 35.45 37.9199 38.9909C37.9199 39.1953 37.9613 39.3884 37.9801 39.5878C39.5631 41.0308 40.8397 42.7918 41.6598 44.8062C42.4783 45.1854 43.3808 45.4115 44.3405 45.4115C47.8815 45.4115 50.7611 42.5318 50.7611 38.9909Z"
              fill="#1C2E4F"
            />
            <path
              d="M18.5984 39.5878C18.6172 39.3884 18.6586 39.1953 18.6586 38.9909C18.6586 35.45 15.7789 32.5703 12.238 32.5703C8.69704 32.5703 5.81738 35.45 5.81738 38.9909C5.81738 42.5318 8.69704 45.4115 12.238 45.4115C13.1977 45.4115 14.1002 45.1854 14.9187 44.8066C15.7388 42.7918 17.0154 41.0308 18.5984 39.5878Z"
              fill="#1C2E4F"
            />
            <path
              d="M4.21191 53.4369V55.149H13.8428V50.2266C13.8428 48.6762 14.1521 47.2102 14.6065 45.8091C13.8528 45.5742 13.0678 45.4111 12.2377 45.4111C7.81263 45.4111 4.21191 49.0118 4.21191 53.4369Z"
              fill="#1C2E4F"
            />
          </g>
          <defs>
            <clipPath id="clip0_0_1587">
              <rect
                width="54.7891"
                height="54.7891"
                fill="white"
                transform="translate(0.894531 0.360352)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      label: "Active Users",
      value: dashboardData?.totalActiveCustomers || "-",
      redirectPath: "/manage-user",
    },
    // {
    //   icn: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="40"
    //       height="40"
    //       viewBox="0 0 56 56"
    //       fill="none"
    //     >
    //       <g clip-path="url(#clip0_0_1587)">
    //         <path
    //           d="M28.2891 15.743L34.3113 18.9094L33.161 12.2033L38.0362 7.45227L31.3004 6.47413L28.2891 0.360352L25.2778 6.47413L18.542 7.45227L23.4172 12.2033L22.2669 18.9094L28.2891 15.743Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M48.6359 17.3882L45.6246 11.2861L42.6133 17.3882L35.8809 18.3663L40.7527 23.1162L39.6024 29.8235L45.6246 26.6571L51.6502 29.8235L50.4965 23.1162L55.684 18.3663L48.6359 17.3882Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M6.082 23.1162L4.9283 29.8235L10.9539 26.6571L16.9761 29.8235L15.8258 23.1162L20.6976 18.3663L13.9652 17.3882L10.9539 11.2861L7.94255 17.3882L0.894531 18.3663L6.082 23.1162Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M36.3152 30.9652C36.3152 26.5402 32.7144 22.9395 28.2894 22.9395C23.8644 22.9395 20.2637 26.5402 20.2637 30.9652C20.2637 35.3902 23.8644 38.9909 28.2894 38.9909C32.7144 38.9909 36.3152 35.3902 36.3152 30.9652Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M17.0527 50.2268V55.1492H39.5248V50.2268C39.5248 44.0319 34.4836 38.9907 28.2888 38.9907C22.0939 38.9907 17.0527 44.0319 17.0527 50.2268Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M52.3663 53.4369C52.3663 49.0118 48.7656 45.4111 44.3405 45.4111C43.5104 45.4111 42.7253 45.5742 41.9717 45.8091C42.4261 47.2102 42.7354 48.6762 42.7354 50.2266V55.149H52.3663V53.4369Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M50.7611 38.9909C50.7611 35.45 47.8815 32.5703 44.3405 32.5703C40.7996 32.5703 37.9199 35.45 37.9199 38.9909C37.9199 39.1953 37.9613 39.3884 37.9801 39.5878C39.5631 41.0308 40.8397 42.7918 41.6598 44.8062C42.4783 45.1854 43.3808 45.4115 44.3405 45.4115C47.8815 45.4115 50.7611 42.5318 50.7611 38.9909Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M18.5984 39.5878C18.6172 39.3884 18.6586 39.1953 18.6586 38.9909C18.6586 35.45 15.7789 32.5703 12.238 32.5703C8.69704 32.5703 5.81738 35.45 5.81738 38.9909C5.81738 42.5318 8.69704 45.4115 12.238 45.4115C13.1977 45.4115 14.1002 45.1854 14.9187 44.8066C15.7388 42.7918 17.0154 41.0308 18.5984 39.5878Z"
    //           fill="#1C2E4F"
    //         />
    //         <path
    //           d="M4.21191 53.4369V55.149H13.8428V50.2266C13.8428 48.6762 14.1521 47.2102 14.6065 45.8091C13.8528 45.5742 13.0678 45.4111 12.2377 45.4111C7.81263 45.4111 4.21191 49.0118 4.21191 53.4369Z"
    //           fill="#1C2E4F"
    //         />
    //       </g>
    //       <defs>
    //         <clipPath id="clip0_0_1587">
    //           <rect
    //             width="54.7891"
    //             height="54.7891"
    //             fill="white"
    //             transform="translate(0.894531 0.360352)"
    //           />
    //         </clipPath>
    //       </defs>
    //     </svg>
    //   ),
    //   label: "New Users",
    //   value: dashboardData?.totalCustomers || "-",
    //   redirectPath: "/manage-user",
    // },
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 53 55"
          fill="none"
        >
          <path
            d="M19.0859 17.9612L16.6931 20.3539L18.9298 22.5906L21.3226 20.1979C22.3496 20.9127 23.5333 21.4158 24.8114 21.6461V25.0267H27.9746V21.6461C29.2526 21.4158 30.4363 20.9127 31.4634 20.1979L33.8561 22.5906L36.0928 20.3539L33.7001 17.9612C34.4148 16.9342 34.918 15.7504 35.1483 14.4725H38.5289V11.3093H35.1483C34.918 10.0313 34.4148 8.8475 33.7 7.82052L36.0927 5.42787L33.856 3.19118L31.4633 5.58382C30.4363 4.86894 29.2525 4.36588 27.9745 4.1355V0.754883H24.8113V4.1355C23.5332 4.36588 22.3495 4.86894 21.3225 5.58382L18.9297 3.19118L16.693 5.42787L19.0858 7.82052C18.371 8.8475 17.8678 10.0313 17.6375 11.3093H14.2568V14.4725H17.6375C17.8679 15.7504 18.371 16.9342 19.0859 17.9612ZM26.3929 7.15509C29.5555 7.15509 32.1286 9.72814 32.1286 12.8908C32.1286 16.0535 29.5555 18.6264 26.3929 18.6264C23.2302 18.6264 20.6571 16.0535 20.6571 12.8908C20.6571 9.72814 23.2302 7.15509 26.3929 7.15509Z"
            fill="#1C2E4F"
          />
          <path
            d="M49.2357 26.4238C46.4932 23.6813 42.0425 23.6653 39.2783 26.3731L27.6099 38.0416H19.5925V34.8784H26.2996L31.167 30.011H16.1269C13.3196 30.011 10.7011 31.397 9.12244 33.7184L0.738281 46.0482L13.6743 54.7551L18.9877 48.2632H33.0837L52.0793 29.2676L49.2357 26.4238Z"
            fill="#1C2E4F"
          />
        </svg>
      ),
      label: "Total Therapist Consultants",
      value: dashboardData?.totalVendors || "-",
      redirectPath: "/service-provider/register",
    },
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 59 55"
          fill="none"
        >
          <path
            d="M51.999 0.964844H46.599V6.36484C46.599 7.44484 45.699 8.16484 44.799 8.16484C43.899 8.16484 42.999 7.44484 42.999 6.36484V0.964844H14.199V6.36484C14.199 7.44484 13.299 8.16484 12.399 8.16484C11.499 8.16484 10.599 7.44484 10.599 6.36484V0.964844H5.19904C2.49904 0.964844 0.519043 3.30484 0.519043 6.36484V12.8448H58.119V6.36484C58.119 3.30484 54.879 0.964844 51.999 0.964844ZM0.519043 16.6248V49.5648C0.519043 52.8048 2.49904 54.9648 5.37904 54.9648H52.179C55.059 54.9648 58.299 52.6248 58.299 49.5648V16.6248H0.519043ZM16.539 46.8648H12.219C11.499 46.8648 10.779 46.3248 10.779 45.4248V40.9248C10.779 40.2048 11.319 39.4848 12.219 39.4848H16.719C17.439 39.4848 18.159 40.0248 18.159 40.9248V45.4248C17.979 46.3248 17.439 46.8648 16.539 46.8648ZM16.539 30.6648H12.219C11.499 30.6648 10.779 30.1248 10.779 29.2248V24.7248C10.779 24.0048 11.319 23.2848 12.219 23.2848H16.719C17.439 23.2848 18.159 23.8248 18.159 24.7248V29.2248C17.979 30.1248 17.439 30.6648 16.539 30.6648ZM30.939 46.8648H26.439C25.719 46.8648 24.999 46.3248 24.999 45.4248V40.9248C24.999 40.2048 25.539 39.4848 26.439 39.4848H30.939C31.659 39.4848 32.379 40.0248 32.379 40.9248V45.4248C32.379 46.3248 31.839 46.8648 30.939 46.8648ZM30.939 30.6648H26.439C25.719 30.6648 24.999 30.1248 24.999 29.2248V24.7248C24.999 24.0048 25.539 23.2848 26.439 23.2848H30.939C31.659 23.2848 32.379 23.8248 32.379 24.7248V29.2248C32.379 30.1248 31.839 30.6648 30.939 30.6648ZM45.339 46.8648H40.839C40.119 46.8648 39.399 46.3248 39.399 45.4248V40.9248C39.399 40.2048 39.939 39.4848 40.839 39.4848H45.339C46.059 39.4848 46.779 40.0248 46.779 40.9248V45.4248C46.779 46.3248 46.239 46.8648 45.339 46.8648ZM45.339 30.6648H40.839C40.119 30.6648 39.399 30.1248 39.399 29.2248V24.7248C39.399 24.0048 39.939 23.2848 40.839 23.2848H45.339C46.059 23.2848 46.779 23.8248 46.779 24.7248V29.2248C46.779 30.1248 46.239 30.6648 45.339 30.6648Z"
            fill="#1C2E4F"
          />
        </svg>
      ),
      label: "Total Appointments Made",
      value: dashboardData?.totalOrders || "-",
      redirectPath: "/order-management",
    },
    {
      icn: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 54 55"
          fill="none"
        >
          <path
            d="M49.6598 42.2189H19.2998C18.3738 40.3269 16.8118 38.8009 14.8618 37.9789V1.25488C14.8618 0.978883 14.6378 0.754883 14.3618 0.754883H4.37379C2.23179 0.754883 0.487793 2.49088 0.487793 4.62488C0.487793 6.75688 2.23179 8.49288 4.37379 8.49288H7.46379V38.3269C4.67979 39.7869 2.75579 42.6729 2.75579 46.0269C2.75579 50.8389 6.67179 54.7549 11.4858 54.7549C14.8618 54.7549 17.7618 52.8069 19.2098 49.9929H49.6598C51.7718 49.9929 53.4878 48.2489 53.4878 46.1069C53.4878 43.9649 51.7698 42.2189 49.6598 42.2189ZM11.4898 49.5969C9.51779 49.5969 7.91779 47.9969 7.91779 46.0249C7.91779 44.0609 9.51779 42.4529 11.4898 42.4529C13.4538 42.4529 15.0538 44.0589 15.0538 46.0249C15.0538 47.9969 13.4538 49.5969 11.4898 49.5969ZM35.8338 18.1589L41.0478 22.5629L35.8338 26.9469V26.2109C35.8338 25.1569 34.9798 24.3029 33.9278 24.3029H29.0358V21.1309H33.9278C34.9798 21.1309 35.8338 20.2769 35.8338 19.2229V18.1589ZM50.1518 6.50488H20.3818C19.2758 6.50488 18.3818 7.40088 18.3818 8.50488V36.5889C18.3818 37.6929 19.2758 38.5889 20.3818 38.5889H50.1518C51.2578 38.5889 52.1518 37.6929 52.1518 36.5889V8.50488C52.1518 7.40088 51.2558 6.50488 50.1518 6.50488ZM45.2378 24.0249L35.1538 32.5029C34.8038 32.7989 34.3678 32.9509 33.9278 32.9509C33.6518 32.9509 33.3798 32.8929 33.1218 32.7729C32.4498 32.4589 32.0198 31.7849 32.0198 31.0429V28.1169H27.1278C26.0738 28.1169 25.2198 27.2629 25.2198 26.2089V19.2189C25.2198 18.1669 26.0738 17.3109 27.1278 17.3109H32.0198V14.0489C32.0198 13.3069 32.4498 12.6309 33.1238 12.3189C33.7938 12.0049 34.5878 12.1109 35.1598 12.5909L45.2438 21.1049C45.6718 21.4689 45.9198 22.0029 45.9198 22.5649C45.9198 23.1269 45.6678 23.6629 45.2378 24.0249Z"
            fill="#1C2E4F"
          />
        </svg>
      ),
      label: "Total Revenue",
      value: dashboardData?.totalRevenue
        ? `$${dashboardData.totalRevenue}`
        : "-",
      redirectPath: "#",
    },
  ];
  return (
    <>
      <Row>
        {data &&
          data.length > 0 &&
          data.map((item, key) => (
            <Col
              key={key}
              lg="4"
              md="4"
              sm="6"
              className="my-2"
              onClick={() => navigate(item.redirectPath)}
              style={{ cursor: "pointer" }}
            >
              <div className="cardCstm border rounded p-3 py-lg-4 d-flex align-items-center gap-10 h-100">
                <div className="icnWrp flex-shrink-0 me-3">{item.icn}</div>
                <div className="content">
                  <h6 className="m-0 fw-bold text-muted py-1">{item.label}</h6>
                  <h4 className="m-0 fw-bold themeBlue py-1">{item.value}</h4>
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default FeatureCard;
